import { summaryStats } from '@/mocks/home';

export default function Verdict() {
  return (
    <section id="verdict" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="rounded-lg border border-background-300 bg-background-50 overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-5">
            <div className="lg:col-span-3 p-6 md:p-9">
              <span className="inline-flex items-center gap-2 text-xs font-medium tracking-wide text-primary-600 uppercase mb-4">
                <i className="ri-lightbulb-flash-line"></i>
                一句话结论
              </span>
              <h2 className="font-heading font-bold text-foreground-950 text-xl md:text-2xl leading-snug mb-4">
                能看、免费，但“靠谱”和“安全”都谈不上有保障，关键在你怎么用
              </h2>
              <p className="text-foreground-700 leading-relaxed text-sm md:text-base mb-4">
                综合来看，神马影院这类站点通常属于没有正规资质、以广告和导流变现的第三方影视聚合站。它的吸引力在于
                <strong className="text-foreground-900 font-semibold">内容免费、找片方便</strong>
                ，但代价是广告密集、域名不稳、付费与隐私缺乏保障。
              </p>
              <p className="text-foreground-700 leading-relaxed text-sm md:text-base">
                最大的风险并不来自“打开网页”，而来自
                <strong className="text-primary-700 font-semibold">诱导下载的 App、乱授予的权限以及站内的登录和付款</strong>
                。只要守住“不装、不授权、不付款”的底线，风险可以被控制；但如果追求长期稳定和省心，正规平台仍是更稳妥的选择。
              </p>
              <div className="mt-6 flex flex-wrap gap-2">
                <span className="px-3 py-1.5 rounded-md bg-primary-100 text-primary-700 text-xs font-medium">
                  可靠性偏低
                </span>
                <span className="px-3 py-1.5 rounded-md bg-secondary-100 text-secondary-800 text-xs font-medium">
                  广告与跳转多
                </span>
                <span className="px-3 py-1.5 rounded-md bg-accent-100 text-accent-700 text-xs font-medium">
                  风险可规避
                </span>
              </div>
            </div>

            <div className="lg:col-span-2 bg-foreground-950 text-background-50 p-6 md:p-9 flex flex-col justify-center">
              <p className="text-sm text-background-300 mb-5 flex items-center gap-2">
                <i className="ri-bar-chart-box-line"></i>
                本页梳理内容一览
              </p>
              <div className="grid grid-cols-2 gap-5">
                {summaryStats.map((s) => (
                  <div key={s.label}>
                    <div className="font-heading font-black text-3xl md:text-4xl text-primary-300">{s.value}</div>
                    <div className="text-xs text-background-300 mt-1 leading-snug">{s.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}